<footer class="footer-area footer-area-v2 bg-tuna">
    <div class="container">
        <div class="footer-area-internal border-0">
            <div class="row">
                <!-- Single Footer Widget -->
<!--                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">-->
<!--                    <div class="single-footer-widget footer-text-widget">-->
<!--                        <h5 class="widget-title">Sanitas Analytica j.d.o.o.</h5>-->
<!--                        <div class="footer-social-links">-->
<!--                            <ul>-->
<!--                                <li><a href="https://www.linkedin.com/company/sanitas-analytica/" target="_blank"><i class="fab fa-linkedin"></i></a></li>-->
<!--                                <li><a href="https://www.youtube.com/@polypharmsolutions" target="_blank"><i class="fab fa-youtube"></i></a></li>-->
<!--                            </ul>-->
<!--                        </div>-->
<!--                    </div> &lt;!&ndash; /.single-footer-widget &ndash;&gt;-->
<!--                </div>-->
                <!-- Single Footer Widget -->
                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s" *ngFor="let data of links">
                    <div class="single-footer-widget">
                        <h5 class="widget-title">{{data.title}}</h5>
                        <div class="footer-widget-menu">
                            <ul>
                                <li *ngFor="let item of data.items"><a routerLink="{{item.link}}">{{item.title}}</a></li>
                            </ul>
                        </div>
                    </div> 
                </div>
                <!-- Single Footer Widget -->
                <div class="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
                    <div class="single-footer-widget contact-us-widget">
                        <h5 class="widget-title">Contact Us</h5>
<!--                        <div class="footer-widget-menu">-->
<!--                            <ul>-->
<!--                                <li><a-->
<!--                                        href="https://www.google.com/maps/place/Croatian+inovation+center+-+ZICER/@45.777984,15.9724977,17z/data=!3m1!4b1!4m5!3m4!1s0x4765d678550a6d87:0x19d4422c69d308a7!8m2!3d45.7779803!4d15.9746917"><i class="fal fa-map-marker-alt"-->
<!--                                ></i>Avenija Dubrovnik 15, Pav. 12, Zagreb, Croatia</a></li>-->
<!--                                <li><a href="https://www.zicer.hr/" target="_blank">-->
<!--                                    <img src="assets/img/partners/zicer-logo-footer.svg" alt="Zicer Logo">-->
<!--                                </a></li>-->
<!--                                <li><a href="mailto:support@sanitasanalytica.com"><i class="fal fa-envelope-open-text"></i>support@sanitasanalytica.com</a></li>-->
<!--                            </ul>-->
<!--                        </div>-->
                    </div> <!-- /.single-footer-widget -->
                </div>
            </div> <!-- /.row -->
        </div> <!-- /.footer-area-internal -->
    </div> <!-- /.container -->
    <div class="footer-copyright-area wow fadeInDown" data-wow-delay="0.8s">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-6 col-sm-4">
                    <div class="footer-logo">
                        <img src="assets/img/logo/polypharm-logo-transparent.png" alt="footer logo white"
                        style="max-width: 35%">
                    </div>
                </div>
                <div class="col-md-6 col-sm-8">
                    <div class="footer-copyright">
                        <p>&copy; 2023 <a href="#">Dionizije Fa</a> All Rights Reserved</p><a href="http://www.freepik.com">Icons designed by brgfx / Freepik</a>
                    </div>
                </div>
            </div> <!-- /.row -->
        </div> <!-- /.container -->
    </div> <!-- /.footer-copyright-area -->
</footer>
<a href="javascript:void(0)" [ngClass]="windowScrolled ? 'd-inline-block':''" (click)="scrollToTop()" class="scroll-to-target scroll-to-top bg-burning-orange"><i class="fa fa-angle-up"></i></a>
